<template>
	<section>
		<div class="d-sm-flex align-items-center justify-content-between mb-4">
	        <h1 class="h3 mb-0 text-gray-800">Histórico da {{view_nome.denuncia_detalhe}}</h1>

	        <router-link :to="{name: 'Denuncias', params: {get: 'Denuncias'} }">
	        	<button class="btn btn-sm btn-success">Voltar</button>
	        </router-link>
	    </div>

		<div class="d-sm-flex justify-content-between mb-3">
			<div class="p-2 mr-1">
				<b>ID: </b> {{ denuncia.id }}
			</div>

			<div class="p-2 mr-1">
				<b>Protocolo: </b> {{ denuncia.protocolo }}
			</div>

			<div class="p-2 mr-1">
				<b>Origem: </b> {{ Phone(denuncia.origem) }}
			</div>

			<div class="p-2 mr-1">
				<b>Data: </b> {{ denuncia.created_at | moment("DD/MM/YYYY") }}
			</div>

			<div class="p-2 mr-1">
				<b>Hora: </b> {{ convert_hor(denuncia.created_at) | moment("HH:mm:ss") }}
			</div>
		</div>

		<hr>

		<player v-if="denuncia.canal === 1" ref="wavesurfer" :audio_hash="audio" />

        <div class="row" v-else>
            <div class="col-12">
                <div class="form-group">
                    <label>{{view_nome.denuncia_detalhe}}</label>
                    <textarea class="form-control" readonly rows="6" v-model="denuncia.denuncia"></textarea>
                </div>
            </div>
        </div>

		<div class="row">
	    	<table class="table table-striped table-hover table-sm table-responsive-xl">
	    		<thead align="center">
	    			<th @click="orderBy('id')"         >ID         <font-awesome-icon v-if="direction.by == 'id'"         :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('data')"       >DATA       <font-awesome-icon v-if="direction.by == 'data'"       :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('hora')"       >HORA       <font-awesome-icon v-if="direction.by == 'hora'"       :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('prioridade')" >PRIORIDADE <font-awesome-icon v-if="direction.by == 'prioridade'" :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('status')"     >STATUS     <font-awesome-icon v-if="direction.by == 'status'"     :icon="order_icon" size="xs" /></th>
	    			<th @click="orderBy('resumo')"     >RESUMO     <font-awesome-icon v-if="direction.by == 'resumo'"     :icon="order_icon" size="xs" /></th>
	    			<th></th>
	    		</thead>

	    		<transition mode="out-in" name="leftIn">
					<tbody v-if="gravacoes" align="center">
		    			<tr v-for="(row, index) in gravacoes.data" :key="index">
							<td>{{ row.id }}</td>
							<td>{{ row.created_at | moment("DD/MM/YYYY") }}</td>
							<td>{{ convert_hor(row.created_at) | moment("HH:mm:ss") }}</td>
							<td><font-awesome-icon icon="flag" :class="priority_color(row.prioridade)" /></td>
							<td>{{ row.status.nome }}</td>
							<td>{{ row.resumo }}</td>
							<td><font-awesome-icon icon="eye" class="info pointer" @click="view(row)" /></td>
						</tr>

		    		</tbody>
		    		<Loading v-else />
				</transition>
	    	</table>
	    </div>

	    <controls :data="constrol_data" @refresh="navigate"  @alert="show_alert" />
		<modal :block="true" :gravacao="modal_data" @alert="show_alert" />
	</section>
</template>

<script>
	import api      from "@/mixins/api.js"
	import replace  from "@/mixins/replace.js"
	import controls from "@/components/Tools/Table_Control.vue"
	import player   from "@/components/Tools/Player.vue"
	import modal    from "@/components/Modal/Denuncia/NotaInterna"

	export default {
		name: "Gravacao",
		mixins: [api, replace],
		components: { controls, player, modal },

		data() { return {
			denuncia: { canal: 1},
			gravacoes: null,
			constrol_data: {},
			audio: null,
			modal_data: {},
			pagination: "10?",
			direction: { order: "desc", by: "id" },
		}},

		computed: {
			logotipo() { return this.$store.state.config.logotipo },

			view_nome(){ return this.$store.state.config_view_menu },

			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down"
			}
		},

		async created() {
			await this.get_denuncia()
			await this.get_audio()
			await this.get_data()
		},

		methods: {
			async get_denuncia() {
				const response = await this.GET("Denuncia", this.$route.params.denuncia_id)
				if ( response.status == 'success' ) this.denuncia = response.result
			},

			async get_audio() {
				const response = await  this.GET("Audio", this.denuncia.gravacao_id)
				//this.audio = response.file || null
				this.carrega_audio(response.path)
			},
			
			async carrega_audio(caminho){
				this.audio = await this.POST("Audio/pegaAudio",{ path: caminho })
			},

			async get_data() {
				const response = await this.GET("Denuncia/Historico", `Paginate/${this.pagination}${this.ordenation}&denuncia_id=${this.$route.params.denuncia_id}`)

				if ( response.status == "success" )
					this.gravacoes = response.result

				this.constrol_data = {
					current_page: this.gravacoes.current_page,
					last_page:    this.gravacoes.last_page,
					per_page:     this.gravacoes.per_page,
					total:        this.gravacoes.total,
				}
			},

			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc'
				}

				else this.direction.by = payload

				this.get_data()
			},

			navigate(payload) {
				this.pagination = payload
				this.get_data()
			},

			show_alert(payload) {
				this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger"
				this.alert.msg  = payload.result

				$("#modal-gravacao").modal('hide')
				this.get_data()
				$("#app-alert").show()
				setTimeout(() => $("#app-alert").hide(), 3000 )
			},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

			view(payload) {
				this.modal_data = payload
				$("#modal-notainterna").modal()
			},
		},
	}
</script>